import React from 'react';
import FilterTable from './filterTable';
import {ProductReleaseTableColumnCaptions} from './tableColumnCaptions';
import {jsonColumn} from './tableUtils';

const ProductReleaseHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: {type: 'datetime'},
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'previous',
    text: 'Previous values',
    filter_: { type: 'text' },
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="productReleasesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previous: jsonColumn(histrec.previousValues, ProductReleaseTableColumnCaptions)
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no product release history records"
    />
  );
};

export default ProductReleaseHistoryTable;



// WEBPACK FOOTER //
// ./src/components/productReleaseHistoryTable.js